import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  CheckoutDeliveryAddressModule,
  CheckoutOrderSummaryModule,
  CheckoutPlaceOrderModule,
  CheckoutProgressModule,
} from '@spartacus/checkout/base/components';
import { I18nModule, UrlModule } from '@spartacus/core';
import { CardModule, FormErrorsModule, OutletModule } from '@spartacus/storefront';
import { CheckoutAddressComponent } from './checkout-address/checkout-address.component';
import { CheckoutOrchestratorComponent } from './checkout-orchestrator/checkout-orchestrator.component';
import { CheckoutReviewComponent } from './checkout-review/checkout-review.component';
import { CheckoutSummaryComponent } from './checkout-summary/checkout-summary.component';
import { FormBillingAddressComponent } from './form-billing-address/form-billing-address.component';
import { OrderDetailsModule } from '@spartacus/order/components';
import { CustomCheckoutProgressComponent } from './checkout-progress/checkout-progress.component';
import { SharedModule } from '@shared/shared.module';
import { FormDeliveryAddressComponent } from './form-delivery-address/form-delivery-address.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormHeaderComponent } from '@shared/form-header/form-header.component';
import { SelectAddressComponent } from '@shared/select-address/select-address.component';

@NgModule({
  declarations: [
    CheckoutSummaryComponent,
    CheckoutOrchestratorComponent,
    CheckoutAddressComponent,
    CheckoutReviewComponent,
    FormBillingAddressComponent,
    FormDeliveryAddressComponent,
    CustomCheckoutProgressComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    UrlModule,
    SharedModule,
    OutletModule,
    I18nModule,
    CheckoutProgressModule,
    CheckoutDeliveryAddressModule,
    CheckoutOrderSummaryModule,
    CardModule,
    CheckoutPlaceOrderModule,
    OrderDetailsModule,
    FormErrorsModule,
    FormHeaderComponent,
    SelectAddressComponent
  ],
})
export class ComponentsModule {}
